import { TradingSection } from '@/src/ui-components';
import { TradingPair } from './trading-pair';

export const Parameters = () => {
  return (
    <TradingSection>
      <TradingSection.Body>
        <TradingPair />
      </TradingSection.Body>
    </TradingSection>
  );
};
